module.exports = __webpack_public_path__ + "static/media/js-gibberish.313393c2.png";